import { Component, Input } from '@angular/core';
import { ToastService } from 'ng-uikit-pro-standard';
import { ServicePlan } from 'src/app/shared-core/models/cart-data.model';
import { CartService } from 'src/app/shared-core/services/cart.service';
@Component({
    selector: 'app-service-plans-row',
    templateUrl: './service-plans-row.component.html',
    styleUrls: ['./service-plans-row.component.scss']
})
export class ServicePlansRowComponent {
    @Input() public parentItemWebCode: string;
    @Input() public servicePlans: ServicePlan[] = [];
    @Input() public isOnCartPage = true;
    public addedWarranty: ServicePlan = null;
    public isLoading = false;

    constructor(private _cartService: CartService, private _toastService: ToastService) {}

    public getPlanImageURL(imgURI: string) {
        if (!imgURI) return 'https://img.vistek.net/prodimg/200/blank.jpg?tr=w-75,h-75';
        let imageName = imgURI.substring(3, imgURI.length - 2);
        return 'https://img.vistek.net/' + imageName;
    }

    public addServicePlan(servicePlan: ServicePlan) {
        this.isLoading = true;

        this._cartService.addServicePlan(this.parentItemWebCode, servicePlan).subscribe((success) => {
            if (!success) {
                this.isLoading = false;
                this._toastService.error('Failed to add service plan to your cart. Please refresh and try again.');
                return;
            }

            this._toastService.success('Successfully added service plan to your cart.');

            if (this.isOnCartPage) {
                this._cartService.reloadShoppingCart(true);
            }

            this.addedWarranty = servicePlan;
            this.isLoading = false;
        });
    }
}
